import * as React from 'react'
import SpinnerOverlay from '../../../shared/spinner_overlay'

type FilterSelectProps = {
  elementId: string
  label: string
  blankLabel: string
  size?: number
  searchEnabled?: boolean
  searchTerm?: string
  selectOptions?: Array<[string, string]>
  showOverlay?: boolean
  selectedValue?: number | string
  handleChange: (value: string) => void
  handleSearchChange?: (value: string) => void
}

class FilterSelect extends React.Component<FilterSelectProps> {

  optionsFromArray () {
    const { selectOptions, searchTerm } = this.props
    if (selectOptions !== undefined) {
      let filtered = selectOptions
      if (searchTerm) {
        const filterFn = (o) => {
          const regexp = new RegExp(`${searchTerm}`, 'i')
          return regexp.test(o[0])
        }
        filtered = selectOptions.filter(filterFn)
      }
      return filtered.map(o => <option key={o[1]} value={o[1]}>{o[0]}</option>)
    }
    return ''
  }

  searchField () {
    if (this.props.searchEnabled == true) {
      return (
        <div className="filter-select-search mb-2">
          <input className="form-control"
            type="text"
            defaultValue={ this.props.searchTerm }
            onChange={ (e) => this.props.handleSearchChange(e.target.value) }
          />
        </div>
      )
    }
  }

  selectSize () {
    const { size, searchEnabled } = this.props
    return searchEnabled ? (size - 2) : size
  }

  render () {
    const { showOverlay, selectedValue } = this.props
    const overlay = showOverlay === undefined ? false : showOverlay
    return (
      <div className="filter-select">
        <div className="label">
          <label htmlFor={this.props.elementId}>
            {this.props.label}
          </label>
        </div>
        <SpinnerOverlay isActive={overlay} >
          <div>
            {this.searchField()}
            <select className="form-control" id={this.props.elementId}
              size={this.selectSize()}
              value={selectedValue || ''}
              onChange={e => this.props.handleChange(e.target.value)}
            >
              <option>{this.props.blankLabel}</option>
              {this.optionsFromArray()}
            </select>
          </div>
        </SpinnerOverlay>
      </div>
    )
  }
}

export default FilterSelect
